/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_Knowledge_Assistants_Retrieve_Title8Inputs */

const en_svc_rag_knowledge_assistants_retrieve_title8 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Retrieve_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chunking and retrieval tuning`)
};

const ar_svc_rag_knowledge_assistants_retrieve_title8 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Retrieve_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التقطيع وضبط الاسترجاع`)
};

const bn_svc_rag_knowledge_assistants_retrieve_title8 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Retrieve_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`চাঙ্কিং ও রিট্রিভাল টিউনিং`)
};

const de_svc_rag_knowledge_assistants_retrieve_title8 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Retrieve_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chunking- und Retrieval-Tuning`)
};

const es_svc_rag_knowledge_assistants_retrieve_title8 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Retrieve_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fragmentación y ajuste de recuperación`)
};

const fr_svc_rag_knowledge_assistants_retrieve_title8 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Retrieve_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Découpage et réglage de récupération`)
};

const pt_svc_rag_knowledge_assistants_retrieve_title8 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Retrieve_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fragmentação e afinação de recuperação`)
};

const zh_svc_rag_knowledge_assistants_retrieve_title8 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Retrieve_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`切分与检索调优`)
};

const tr_svc_rag_knowledge_assistants_retrieve_title8 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Retrieve_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parçalama ve getirme ayarı`)
};

const ru_svc_rag_knowledge_assistants_retrieve_title8 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Retrieve_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Чанкинг и настройка поиска`)
};

const pl_svc_rag_knowledge_assistants_retrieve_title8 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Retrieve_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chunking i strojenie wyszukiwania`)
};

/**
* | output |
* | --- |
* | "Chunking and retrieval tuning" |
*
* @param {Svc_Rag_Knowledge_Assistants_Retrieve_Title8Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_rag_knowledge_assistants_retrieve_title8 = /** @type {((inputs?: Svc_Rag_Knowledge_Assistants_Retrieve_Title8Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_Knowledge_Assistants_Retrieve_Title8Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_rag_knowledge_assistants_retrieve_title8(inputs)
	if (locale === "bn") return bn_svc_rag_knowledge_assistants_retrieve_title8(inputs)
	if (locale === "de") return de_svc_rag_knowledge_assistants_retrieve_title8(inputs)
	if (locale === "es") return es_svc_rag_knowledge_assistants_retrieve_title8(inputs)
	if (locale === "fr") return fr_svc_rag_knowledge_assistants_retrieve_title8(inputs)
	if (locale === "pt") return pt_svc_rag_knowledge_assistants_retrieve_title8(inputs)
	if (locale === "zh") return zh_svc_rag_knowledge_assistants_retrieve_title8(inputs)
	if (locale === "tr") return tr_svc_rag_knowledge_assistants_retrieve_title8(inputs)
	if (locale === "ru") return ru_svc_rag_knowledge_assistants_retrieve_title8(inputs)
	if (locale === "pl") return pl_svc_rag_knowledge_assistants_retrieve_title8(inputs)
	return en_svc_rag_knowledge_assistants_retrieve_title8(inputs)
});
export { svc_rag_knowledge_assistants_retrieve_title8 as "svc_rag-knowledge-assistants_RETRIEVE_title" }